module.exports = __webpack_public_path__ + "static/media/affiliate.2a746588.png";